export const SIBLING_PAGES_RANGE = 2;

export const MAX_START_SIBLING_RANGE_PAGE = 6;
